import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProviders, useSettings } from "./contexts/AppContext";
import Navbar from "./Pages/components/Navbar";
import LyricsPanel from "./Pages/components/LyricsPanel";
import MusicPlayer from "./Pages/components/MusicPlayer";
import MetaTags from "./Pages/components/MetaTags";
import { LoadingSpinner, ShopGuard, FanClubGuard, FanClubMemberGuard, ConcertsGuard, ConditionalCartDrawer } from "./Pages/components/Guards";
import HomePage from "./Pages/HomePage";
import MusicPage from "./Pages/MusicPage";
import StorePage from "./Pages/StorePage";
import ProductDetailPage from "./Pages/ProductDetailPage";
import TourPage from "./Pages/TourPage";
import FanClubPage from "./Pages/FanClubPage";
import NewsPage from "./Pages/NewsPage";
import NewsArticlePage from "./Pages/NewsArticlePage";
import AboutPage from "./Pages/AboutPage";
import ContactPage from "./Pages/ContactPage";
import PrivacyPage from "./Pages/PrivacyPage";
import TermsPage from "./Pages/TermsPage";
import CheckoutSuccessPage from "./Pages/CheckoutSuccessPage";
import ProfilomPage from "./Pages/ProfilomPage";
import VasarlasaimPage from "./Pages/VasarlasaimPage";
import JelszoModositasPage from "./Pages/JelszoModositasPage";

const MIN_LOADING_MS = 1200; // minimum idő (ms), amíg a kezdőképernyő látszik

function AppContent() {
  const { _loaded } = useSettings();
  const [minElapsed, setMinElapsed] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setMinElapsed(true), MIN_LOADING_MS);
    return () => clearTimeout(t);
  }, []);
  const showContent = _loaded && minElapsed;
  if (!showContent) return <LoadingSpinner />;
  return (
    <div className="App min-h-screen bg-[#080808]">
      <BrowserRouter>
          <MetaTags />
          <Navbar />
          <ConditionalCartDrawer />
          <LyricsPanel />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/zene" element={<MusicPage />} />
            <Route path="/bolt" element={<ShopGuard><StorePage /></ShopGuard>} />
            <Route path="/bolt/:slug" element={<ShopGuard><ProductDetailPage /></ShopGuard>} />
            <Route path="/koncertek" element={<ConcertsGuard><TourPage /></ConcertsGuard>} />
            <Route path="/hirek" element={<NewsPage />} />
            <Route path="/hirek/:slug" element={<NewsArticlePage />} />
            <Route path="/fan-club" element={<FanClubGuard><FanClubPage /></FanClubGuard>} />
            <Route path="/rolam" element={<AboutPage />} />
            <Route path="/kapcsolat" element={<ContactPage />} />
            <Route path="/adatvedelem" element={<PrivacyPage />} />
            <Route path="/aszf" element={<TermsPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/profilom" element={<FanClubMemberGuard><ProfilomPage /></FanClubMemberGuard>} />
            <Route path="/vasarlasaim" element={<FanClubMemberGuard><VasarlasaimPage /></FanClubMemberGuard>} />
            <Route path="/jelszo-modositas" element={<FanClubMemberGuard><JelszoModositasPage /></FanClubMemberGuard>} />
          </Routes>
          <MusicPlayer />
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

function App() {
  return (
    <AppProviders>
      <AppContent />
    </AppProviders>
  );
}

export default App;
